import React, { createContext } from 'react';

export const ProfileContext = createContext();
